/*=============================================== ProgressBarPage ===============================================*/

import { ProgressBar, getRandomNumber } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const ProgressBarPage = () => {
    const randomNumber = getRandomNumber()

    const items: ItemType[] = [
        {
            content: <ProgressBar value={randomNumber} />,
            code: `<ProgressBar value={${randomNumber}} />`,
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "value",
            type: "number",
            required: true,
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "animated",
            type: "boolean",
            default: "true",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ProgressBarPage
